export default __webpack_public_path__ + "static/media/addressblack.2ec5e1c9.svg";